import * as Yup from 'yup';
import { UserAuthData } from 'src/types/user';
import { AppController } from 'app/controllers';
import { Navigation } from 'app/services/navigation';
import { Routes } from 'src/types/routes';
import { AppViewModel } from '..';
import { NotificationTypes } from '../components/NotificationsViewModel';

export const loginValidationSchema: Yup.ObjectSchema<UserAuthData> = Yup.object().shape({
    email: Yup.string().email("It's not a valid email").required('Email required'),
    password: Yup.string().min(6, 'Min 5 chars').required('Password required'),
});

export class LoginPageViewModel {
    get error() { return AppController.Instance.Auth.error; }
    get isLoading() { return AppController.Instance.Auth.isLoading; }

    submitLoginForm = async (userCredentials: UserAuthData) => {
        await AppController.Instance.Auth.logIn({
            email: userCredentials.email,
            password: userCredentials.password,
        });

        if (this.error) {
            AppViewModel.Instance.notifications.setNotification(this.error, NotificationTypes.error);
            return;
        }

        Navigation.value.push(Routes.Dashboard.Home);
    };

    nagivateToTheSignup = () => {
        Navigation.value.push(Routes.Dashboard.Signup);
    };

    navigateToTheResetPassword = () => {
        Navigation.value.push(Routes.Dashboard.ResetPassword);
    };

    signInWithGoogle = async () => {
        await AppController.Instance.Auth.signInWithOAuth('google');
    };

    signInWithApple = async () => {
        await AppController.Instance.Auth.signInWithOAuth('apple');
    };
}
